var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sites-dashboard"},[_c('UserMenu'),_c('div',{staticClass:"main-panel"},[_c('TopNav'),_c('Outages'),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }